// extracted by mini-css-extract-plugin
export default {"funnelSelector":"src-feature-web-capture-__lead-form_funnelSelector"};